import * as React from 'react';
import Svg, {
  SvgProps,
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
  ClipPath,
} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={380}
    height={87}
    viewBox={'0 0 380 87'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <G clipPath="url(#a)">
      <Path
        fill="url(#b)"
        fillOpacity={0.9}
        fillRule="evenodd"
        d="M 184 19 H 346.5 c 18.502 0 33.5 14.998 33.5 33.5 c 0 18.501 -14.998 33.5 -33.5 33.5 h -313 C 14.998 87 0 72.001 0 53.5 C 0 34.998 14.998 20 33.5 20 Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={177.186}
        x2={177.186}
        y1={20}
        y2={87}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#009F9C" />
        <Stop offset={1} stopColor="#007BB2" />
      </LinearGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h380v87H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SvgComponent;
